import { useState } from 'react'

import { Separator, SimpleAlert, DropdownMenu, DropdownMenuTrigger, DropdownMenuContent } from 'twyne-new.ui';

import { ActiveForm } from '@/components/form/ActiveSwitch';
import HeaderContainerForm from '@/components/headerContainer/Form';
import QuickActionsButton from '@/components/headerContainer/QuickActionsButton'
import { formatDateTime } from '@/utils';
import history from '@/utils/history';
import { useStatusForm } from '@Components/form/context';
import PageVariablesModal, { PageVariablesMenuItem } from 'components/modals/PageVariablesModal';

function PathHeading({ data, active, onChangeActive }) {
  const { status } = useStatusForm()
  const [variablesOpen, setVariablesOpen] = useState(false)

  return <>
    <HeaderContainerForm
      title='Path'
      data={{ ...data, createdAt: formatDateTime(data?.created_at), updatedAt: formatDateTime(data?.updated_at) }}
      onCancel={() => history.goBack()}
    >
      {(status.hasChange && data?.id) && <SimpleAlert variant='warning' className='px-4 py-2'>
        You have unsaved changes
      </SimpleAlert>}
      <ActiveForm active={active} onChangeActive={onChangeActive} />
      <Separator orientation='vertical' className='py-5' />
      <DropdownMenu optionsLabel='Options' modal={false}>
        <DropdownMenuTrigger className='flex items-center gap-1'>
          <QuickActionsButton />
        </DropdownMenuTrigger>
        <DropdownMenuContent align='start'>
          <PageVariablesMenuItem onSelect={() => setVariablesOpen(true)} />
        </DropdownMenuContent>
      </DropdownMenu>
    </HeaderContainerForm>
    <PageVariablesModal open={variablesOpen} onOpenChange={setVariablesOpen} />
  </>
}

export default PathHeading
